import FormItem from './_src/formItem.vue'
FormItem.install = function(Vue) {
  Vue.component(FormItem.name, FormItem)
}
export default FormItem